import { render, staticRenderFns } from "./suporte-salas-centros-cirurgicos.vue?vue&type=template&id=0a71e80b"
import script from "./suporte-salas-centros-cirurgicos.vue?vue&type=script&lang=ts"
export * from "./suporte-salas-centros-cirurgicos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports